import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M21.5,5.5H17.75a.25.25,0,0,1-.25-.25V5a4,4,0,0,0-4-4h-3a4,4,0,0,0-4,4v.25a.25.25,0,0,1-.25.25H2.5A2.5,2.5,0,0,0,0,8v4.5A1.5,1.5,0,0,0,1.5,14H9.7a.28.28,0,0,0,.21-.1,2.47,2.47,0,0,1,4.18,0,.28.28,0,0,0,.21.1h8.2A1.5,1.5,0,0,0,24,12.5V8A2.5,2.5,0,0,0,21.5,5.5ZM10.5,3h3a2,2,0,0,1,2,1.71.23.23,0,0,1-.06.2.25.25,0,0,1-.19.09H8.77a.25.25,0,0,1-.19-.09.23.23,0,0,1-.06-.2A2,2,0,0,1,10.5,3Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M12,19.25A3,3,0,0,1,9.25,16a1.69,1.69,0,0,1,0-.23.26.26,0,0,0-.07-.19A.25.25,0,0,0,9,15.5H2a.51.51,0,0,0-.5.43c-.06.42-.13.86-.2,1.29-.35,2-.67,3.91.25,5a2.46,2.46,0,0,0,2,.78H20.46a2.46,2.46,0,0,0,2-.78c.92-1.09.6-3,.25-5-.07-.43-.14-.87-.2-1.29a.51.51,0,0,0-.5-.43H15a.25.25,0,0,0-.18.08.26.26,0,0,0-.07.19,1.69,1.69,0,0,1,0,.23A3,3,0,0,1,12,19.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("ellipse", {
        cx: "12",
        cy: "16",
        rx: "1.25",
        ry: "1.75",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }